<template>
  <v-container class="mt-12 pt-8" style="background: #fafafa;">
    <v-row style="background: #fafafa;">
      <v-col cols="12" class="mx-auto" PANNELS>
        <v-card>
          <v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`">
            {{ i18n["visa"] }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="(key, index) in Object.keys(visa_data_keys)"
                :key="`key-${index}`"
                cols="12"
                md="3"
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                class="mb-4 py-0"
              >
                <div style="font-weight: 700;">
                  {{ i18n[key] }}
                </div>
                <div>
                  <template v-if="visa_data_keys[key] != 'date'">
                    {{ getUserValueFromTheKey(key, visa_data_keys[key]) }}
                  </template>
                  <template v-else-if="visa_data_keys[key] == 'date'">
                    <v-chip color="blue darken-1" dark small>
                      {{ getUserValueFromTheKey(key, visa_data_keys[key])[0] }}
                    </v-chip>
                    <v-chip color="blue darken-1" dark class="mr-2" small>
                      {{ getUserValueFromTheKey(key, visa_data_keys[key])[1] }}
                    </v-chip>
                  </template>
                  <template v-if="visa_data_keys[key] == 'url' && getUserValueFromTheKey(key, visa_data_keys[key])">
                    <v-btn
                      dark
                      v-clipboard:copy="getUserValueFromTheKey(key, visa_data_keys[key])"
                      color="indigo darken-1"
                      x-small
                    >
                      {{ i18n.copy }}
                      <v-icon size="14" class="mr-1">link</v-icon>
                    </v-btn>
                    <v-btn
                      dark
                      :href="getUserValueFromTheKey(key, visa_data_keys[key])"
                      target="_blank"
                      color="blue darken-1"
                      class="mr-1"
                      x-small
                    >
                      {{ i18n.open }}
                      <v-icon size="14" class="mr-1">open_in_new</v-icon>
                    </v-btn>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      visa_data_keys: {
        accelerated_procedure_documents_ready: "bool",
        accelerated_procedure_submitted: "bool",
        accelerated_procedure_result: "bool",
        accelerated_procedure_result_document: "url",
        ba_documents_ready: "bool",
        ba_submitted: "bool",
        ba_result: "bool",
        ba_result_document: "url",
        visa_appointment: "date",
        visa_application_ready: "bool",
        visa_application_submitted: "bool",
        visa_granted: "bool",
        visa_granted_document: "url",
        booked_airline_ticket: "bool",
        airline_ticket_document: "url",
        in_germany_date: "date",
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    getUserValueFromTheKey(key, key_type) {
      const value = this.user[key];

      if (key_type == "bool") {
        const bool_val = Boolean(value);
        return bool_val ? this.i18n.yes : this.i18n.no;
      }

      if (key_type == "url") {
        if (value && value.url) {
          return value.url[0];
        }
        return null;
      }

      if (key_type == "date") {
        return this.formatDateToCurrentLocale(value);
      }
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
  },
};
</script>
